/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import * as React from 'react';
import './RecentCurves.scss';
import { Flex } from '@vaisala-rockhopper/components';
import { CurveData } from '../../../../../modules/ChemicalDataController';
import CurveCard from '../../cards/CurveCard';
import { isMobileOnly } from 'react-device-detect';

interface RecentCurvesProps {
  recentChemicals: CurveData[]
  onChemicalChanged(id: number): void
}

const RecentCurves = ({recentChemicals, onChemicalChanged}: RecentCurvesProps) => {

  return (
    <div className={`recent-curves ${isMobileOnly ? 'recent-curves--mobile' : 'recent-curves--desktop'}`}>
      <Flex
          alignContent="stretch"
          justifyContent="flex-start"
          flexDirection="column"
          flexWrap="nowrap"
          alignItems="stretch"
      >
        {recentChemicals.map((val: CurveData, i: number) => {
          return (
            <CurveCard
              key={i}
              cardData={val}
              onChemicalChanged={onChemicalChanged}
            />
          );
        })}
      </Flex>
    </div>
  );
};
export default RecentCurves;
